import { baseApi } from '@/services'
import { PaginatedResults, TitleOrder } from '@/types/unlock'

/**
 * TitleOrder
 */
export const titleOrderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTitleOrder: builder.query<PaginatedResults<TitleOrder[]>, Partial<TitleOrder>>({
      query: (params) => ({
        url: 'v2/title-orders/',
        params: params,
      }),
      providesTags: ['TitleOrder'],
    }),
    createTitleOrder: builder.mutation<TitleOrder, Partial<TitleOrder>>({
      query: (body) => ({
        method: 'POST',
        url: 'v2/title-orders/',
        body,
      }),
      invalidatesTags: [
        'TitleOrder',
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationCalcs',
      ],
    }),
    updateTitleOrder: builder.mutation<TitleOrder, Partial<TitleOrder>>({
      query: (body) => ({
        method: 'PATCH',
        url: `v2/title-orders/${body.uuid}/`,
        body,
      }),
      invalidatesTags: ['TitleOrder'],
    }),
    uploadFiles: builder.mutation<any, any>({
      query: ({ titleOrderUUID, documents }) => ({
        method: 'POST',
        url: `v2/title-orders/${titleOrderUUID}/upload-docs/`,
        body: { documents },
      }),
      invalidatesTags: [
        'TitleOrder',
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationCalcs',
      ],
    }),
  }),
})

export const {
  useCreateTitleOrderMutation,
  useGetTitleOrderQuery,
  useUpdateTitleOrderMutation,
  useUploadFilesMutation,
} = titleOrderApi
